import Fetch from "../../utils/Fetch";

let loadPawnsListTimeout;

export default {
    namespaced: true,
    state: {
        pawnsList: [],
        pawnsFilters: {
            city: '',
            region: '',
            district: '',
            services: [],
            accepts: [],
            sales: [],
            address: '',
            is_open: true,
            offset: 0,
            limit: 10
        },
        currentPawn: null,
        currentViewMode: 'map',
        pawnsFiltersData: {},
        showClosest: false,
        pawnsTotal: 0,
        showOnMap: false
    },
    mutations: {
        setPawnsFiltersData(state, data) {
            if (!data) return
            state.pawnsFiltersData = data
        },
        setPawnsFiltersKey(state, {key, value}) {
            state.pawnsFilters[key] = value
            this.dispatch('pawns/loadPawnsList')
        },
        setPawnsList(state, {pawns, total}) {
            state.pawnsList = pawns || []
            state.pawnsTotal = total || 0
        },
        setCurrentViewMode(state, val) {
            state.showClosest = false
            state.pawnsList = []
            state.currentViewMode = val
            this.dispatch('pawns/loadPawnsList')
        },
        setCurrentPawn(state, val) {
            state.currentPawn = val
        },
        setShowClosest(state, val) {
            state.showClosest = val
        },
        clearAdditionalFilters(state) {
            state.pawnsFilters = {
                city: state.pawnsFilters.city,
                region: state.pawnsFilters.region,
                district: '',
                services: [],
                accepts: [],
                sales: [],
                address: '',
                is_open: true,
                offset: 0,
                limit: 10
            }
        },
        clearPawnsFilter(state) {
            state.pawnsFilters = {
                city: '',
                region: '',
                district: '',
                services: [],
                accepts: [],
                sales: [],
                address: '',
                is_open: true,
                offset: 0,
                limit: 10
            }
        },
        setShowOnMap(state) {
            state.showOnMap = !state.showOnMap
        }
    },
    actions: {
        loadFiltersData({commit}) {
            return new Promise(resolve => {
                Fetch('pawns/filter/list/').then(response => {
                    if (response.success) {
                        commit('setPawnsFiltersData', response.data)
                    }
                    resolve(response);
                })
            })
        },
        buildRoute({commit}, {pawnData}) {
            commit('setCurrentPawn', pawnData)
            commit('setCurrentViewMode', 'map')
        },
        loadPawnsList({commit, state}) {
            clearTimeout(loadPawnsListTimeout);
            loadPawnsListTimeout = setTimeout(() => {
                let url = new URL('https://fl-dev.xpager.ru/api/desktop/pawns/');
    
                Object.entries(state.pawnsFilters).forEach(([key, value]) => {
                    if (key === 'offset' || key === 'limit') {
                        if (state.currentViewMode === 'list') {
                            url.searchParams.set(`${key}`, String(value))
                        } else {
                            if (key === 'offset') url.searchParams.set(`${key}`, String(0))
                            if (key === 'limit') url.searchParams.set(`${key}`, String(1000))
                        }
                    } else {
                        if (Array.isArray(value)) {
                            if (value.length) {
                                for (let i = 0; i <= value.length - 1; i++) {
                                    url.searchParams.append(`${key}[]`, value[i])
                                }
                            }
                        } else if (typeof value === 'boolean') {
                            if (value) {
                                url.searchParams.set(`${key}`, String(Number(value)))
                            }
                        } else {
                            if (value) url.searchParams.set(`${key}`, String(value))
                        }
                    }
                })
                Fetch(`pawns/${url.search}`).then(response => {
                    if (response.success) {
                        if (typeof(window.history) != 'undefined') {
                            url.searchParams.delete('offset');
                            url.searchParams.delete('limit');
                            url.searchParams.delete('is_open');
                            url.searchParams.delete('region');
                            url.searchParams.delete('city');

                            (new URL(location.href)).searchParams.forEach(
                                (val, key) => !url.searchParams.get(key) ? url.searchParams.append(key, val) : null
                            );
                            window.history.replaceState(null, null, `${location.pathname}${url.search}`);
                        }
                        commit('setPawnsList', {
                            pawns: response.data.pawns,
                            total: response.data.total_count
                        })
                    }
                })
            }, 500);
        },
        async loadCityPawns({commit, rootState}) {
            let response = await Fetch(`pawns/?city=${rootState.location.userCity.id}`)
            if (response.success) {
                commit('setPawnsList', {
                    pawns: response.data.pawns,
                    total: response.data.total_count
                })
            }
        }
    },
    getters: {
        getPawnsList: state => state.pawnsList,
        getPawnsFilters: state => state.pawnsFilters,
        getPawnsFiltersData: state => state.pawnsFiltersData,
        getCities: state => regionId => {
            if (!regionId) return []
            else return state.pawnsFiltersData.cities?.filter(i => i.region === regionId) || []
        },
        getDistricts: state => {
            return cityId => {
                if (!cityId) return []
                let city = state.pawnsFiltersData.cities?.find(i => i.id === cityId)
                if (!city) return []
                else return state.pawnsFiltersData.districts?.filter(i => city.districts.indexOf(i.id) !== -1) || []
            }
        },
        getPawnsFilterKey: state => key => state.pawnsFilters[key],
        getPawnWorkDays: state => {
            return (pawnId) => {
                if (!state.pawnsList.length) return []
                let pawn = state.pawnsList.find(i => i.id === pawnId)
                if (!pawn || !pawn.schedule.length) return []

                let filteredSchedule = pawn.schedule.reduce((a, b) => {
                    if (!Array.isArray(a)) a = [[a]]

                    let last = a[a.length - 1]

                    if (!Array.isArray(last)) {
                        a[a.length - 1] = []
                        a[a.length - 1].push(b)
                    } else if (Array.isArray(last) && last[0].schedule === b.schedule) {
                        a[a.length - 1].push(b)
                    } else {
                        a.push([b]);
                    }
                    return a;
                })
                return filteredSchedule
            }
        },
        getPawnFormattedWorkDays: (state, getters) => {
            return (pawnId) => {
                const formattedSchedule = [];

                const schedules = getters.getPawnWorkDays(pawnId)[0];


                for (let i = 0; i < schedules.length; i++) {

                    if (i === 0) {
                        formattedSchedule.push({
                            firstDay: schedules[0].name_short,
                            lastDay: null,
                            schedule: schedules[0].work_time
                        })
                    }

                    if (schedules[i - 1]) {
                        if (schedules[i - 1].work_time === schedules[i].work_time) {
                            formattedSchedule[formattedSchedule.length - 1].lastDay = schedules[i].name_short;
                        } else {
                            formattedSchedule[formattedSchedule.length - 1].lastDay = schedules[i - 1].name_short;
                            formattedSchedule.push({
                                firstDay: schedules[i].name_short,
                                lastDay: schedules[i].name_short,
                                schedule: schedules[i].work_time
                            })
                        }

                    }
                }
                return formattedSchedule
            }
        },
        getShowCloses: state => state.showClosest,
        getShowOnMap: state => state.showOnMap,
        getCurrentViewMode: state => state.currentViewMode,
        getPawnsTotal: state => state.pawnsTotal,
        getCurrentPawn: state => state.currentPawn,
        getCurrentRegion: state => state.pawnsFilters['region'],
    }
}
